import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-section02',
  templateUrl: './section02.component.html',
  styleUrls: ['./section02.component.scss']
})

export class Section02Component implements OnInit {

  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
